import React from 'react'
import { useHistory } from 'react-router'

const Normal = () => {
  const history = useHistory()

  const gotoError = React.useCallback(() => {
    history.push('/test/error')
  }, [history])

  return <div onClick={gotoError}>Go to error</div>
}

export default Normal
